module.exports = __webpack_public_path__ + "static/the-wave-machine-fcc19e2b369009d35e3f7f4d724ad20d.svg";